import React from 'react'
import { useI18n } from '../../i18n'
import type { ReadinessSystemRow } from '../../services/complianceReadinessApi'
import wfStyles from '@/styles/pages/compliance-workflow/ComplianceWorkflow.module.scss'

interface Props {
  systems?: ReadinessSystemRow[]
  standardReadiness?: { readinessStatus?: string }
}

export default function WorkflowReadinessSummary({ systems = [], standardReadiness }: Props) {
  const { t } = useI18n()
  if (!systems.length) return null

  return (
    <div className={wfStyles.innerStack}>
      {standardReadiness?.readinessStatus ? (
        <p className={wfStyles.itemMeta}>
          {t('complianceReadiness.standardReadiness', 'Standard readiness')}:{' '}
          <strong>{standardReadiness.readinessStatus}</strong>
        </p>
      ) : null}
      {systems.map((s) => (
        <div key={s.informationSystemId} className={wfStyles.listItem}>
          <p className={wfStyles.itemTitle}>
            <span className={wfStyles.monoId}>{s.informationSystemId.slice(0, 8)}</span>
            {s.readiness?.readinessStatus ? (
              <span className="ml-2">{s.readiness.readinessStatus}</span>
            ) : null}
          </p>
          {s.progress?.controlsSatisfiedLabel ? (
            <p className={wfStyles.itemMeta}>
              {t('complianceExecution.progress.controls', 'Controls')}: {s.progress.controlsSatisfiedLabel}{' '}
              {t('complianceReadiness.satisfied', 'satisfied')}
            </p>
          ) : null}
          {s.readiness?.evidenceCoverage != null ? (
            <p className={wfStyles.itemMeta}>
              {t('complianceTopology.evidenceCoverage', 'Evidence coverage')}: {s.readiness.evidenceCoverage}%
            </p>
          ) : null}
        </div>
      ))}
    </div>
  )
}
